import { render, staticRenderFns } from "./guest-footer.vue?vue&type=template&id=3966c374"
import script from "./guest-footer.vue?vue&type=script&lang=js"
export * from "./guest-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3966c374')) {
      api.createRecord('3966c374', component.options)
    } else {
      api.reload('3966c374', component.options)
    }
    module.hot.accept("./guest-footer.vue?vue&type=template&id=3966c374", function () {
      api.rerender('3966c374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/layouts/guest-footer.vue"
export default component.exports